import axios from "axios";

export const state = {
    reportwithdrawsbymonths: [],
};

export const getters = {
    reportwithdrawsbymonths: state => state.reportwithdrawsbymonths,
};

export const mutations = {
    setReportWithdrawsbyMonths(reportwithdrawsbymonths, newValue) { state.reportwithdrawsbymonths = newValue},
};

export const actions = {
    async fetchReportWithdrawsbyMonths({ commit }) {
        await axios.get('/reportwithdrawsbymonths').then(res => {
            commit('setReportWithdrawsbyMonths', res.data.withdraws)
        })
    },
    async filterReportWithdrawsbyMonths({commit}, {month,year}) { 
        let formData = new FormData();
        formData.append("month", month);
        formData.append("year", year);
        let url = "/filterreportwithdrawsbymonths";
        await axios.post(url, formData).then((response) => {
            commit('setReportWithdrawsbyMonths', response.data.withdraws)
        })
    },
};
